import { useEffect } from 'react'

import { useMsal } from '@azure/msal-react'

import { CONTROL_CENTRE_API_DOMAIN } from '@/config/constants'
import useAuthenticatedQuery from '@/hooks/useAuthenticatedQuery'
import { useAuthStore, type UserPermissions } from '@/stores/auth.store'

const useUserPermissions = () => {
  const { accounts } = useMsal()
  const setPermissions = useAuthStore((s) => s.setPermissions)
  const setPermissionsError = useAuthStore((s) => s.setPermissionsError)

  const { data, isError } = useAuthenticatedQuery<UserPermissions>(
    ['user-permissions'],
    `${CONTROL_CENTRE_API_DOMAIN}/user/permissions`,
    {
      enabled: accounts.length > 0,
      refetchInterval: Infinity,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  )

  useEffect(() => {
    if (data) {
      setPermissions(data)
    }
  }, [data, setPermissions])

  useEffect(() => {
    setPermissionsError(isError)
  }, [isError, setPermissionsError])
}

export default useUserPermissions
